import TestManger from "pages/dashboard/shared/TestManger/TestPrograms";
import { FC } from "react";

interface SchoolTestSectionProps {}

const SchoolTestSection: FC<SchoolTestSectionProps> = () => {
  return <TestManger />;
};
export default SchoolTestSection;
